import { useState } from "react";
import EventoInfo from "./lado-izq/EventoInfo";
import EventoTarifas from "./lado-dcho/EventoTarifas";
import Sponsors from "./lado-izq/Sponsors";
import Footer from "../../../../../../components/Footer";
import PublicDisponibilidadModal from "../../../../../../components/modales/ubicaciones/PublicDisponibilidadModal";
import { Button, } from '@mui/material';
import {  Visibility } from '@mui/icons-material';

export const ContentDesktop = ({ data, cantidad, toggleDrawer, setCantidad, tarifasTicketsFiltrados, tarifasVouchersFiltrados, setTarifasSeleccionadas, asientosSeleccionados,
  setAsientosSeleccionados, }) => {

  const [openMapaModal, setOpenMapaModal] = useState(false);

  // si o si visionario
  const esEventoVisionario = data?.id === 461;

  const zonaVisionario = {
    id: 468,
    ubicacion: "Vizenzo"
  };

  const abrirMapa = () => {
    setOpenMapaModal(true);
  };

  return (
    <>
      <div className="d-flex flex-column justify-content-between align-items-center" style={{ padding: "0 4%", width: "100%", maxWidth: "1400px", margin: "0 auto" }}>
        <div className="d-flex justify-content-between w-100">
          <EventoInfo data={data} />

          {esEventoVisionario ? (
            <div className="w-100 pb-4" style={{ maxWidth: "400px", marginRight: "40px", position: "sticky", top: "0", paddingTop: "28px" }}>
              <Button
                variant="contained"
                size="large"
                startIcon={<Visibility />}
                onClick={abrirMapa}
                sx={{
                  backgroundColor: "#5656ff",
                  borderRadius: '10px',
                  py: 1,
                  px: 2,
                  fontSize: '16px',
                  /* fontWeight: 600, */
                  color:"white",
                  textTransform: 'none',
                  boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                  '&:hover': {
                    backgroundColor: '#0b0060',
                    transform: 'translateY(-1px)',
                  },
                  transition: 'all 0.2s ease'
                }}
                fullWidth
              >
                Ver mapa del evento
              </Button>
            </div>
          ) : (
            <EventoTarifas
              data={data}
              cantidad={cantidad}
              toggleDrawer={toggleDrawer}
              setCantidad={setCantidad}
              tarifasTicketsFiltrados={tarifasTicketsFiltrados}
              tarifasVouchersFiltrados={tarifasVouchersFiltrados}
              setTarifasSeleccionadas={setTarifasSeleccionadas}
              asientosSeleccionados={asientosSeleccionados}
              setAsientosSeleccionados={setAsientosSeleccionados}
            />
          )}
        </div>
        <Sponsors sponsors={data?.sponsors} />
      </div>

      <PublicDisponibilidadModal
        open={openMapaModal}
        onClose={() => setOpenMapaModal(false)}
        zona={zonaVisionario}
      />

      <Footer />
    </>
  );
}